export default "__VITE_ASSET__Do9nivSS__"